"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributorsTab = void 0;
const mobx_react_1 = require("mobx-react");
const React = require("react");
const distributor_list_1 = require("./components/distributor-list");
require("./distributors.less");
let DistributorsTab = class DistributorsTab extends React.Component {
    render() {
        return React.createElement(distributor_list_1.DistributorsList, null);
    }
};
DistributorsTab = __decorate([
    mobx_react_1.observer
], DistributorsTab);
exports.DistributorsTab = DistributorsTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/distributors/distributors.tsx
// module id = 3512
// module chunks = 0